<div class="background">
	<i class="fa fa-cog" aria-hidden="true"></i>
</div>